import { useAuth0 } from "@auth0/auth0-react";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import "twin.macro";
import { Button } from "../../components/buttons";
import { PageContainer, PageHeader } from "../../components/page";
import { HasChildren } from "../../types/shared";

type ErrorPageProps = HasChildren & {
  title?: ReactNode;
  subtitle?: string;
};

export const ErrorPage = ({ title, children }: ErrorPageProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <PageContainer>
      <PageHeader>{title}</PageHeader>
      {children}
      <Button white onClick={() => navigate("/")} tw="w-fit">
        {t("action.backToDashboard")}
      </Button>
    </PageContainer>
  );
};

export const ErrorComponent = ({ subtitle }: { subtitle?: string }) => {
  const { t } = useTranslation();
  const { logout } = useAuth0();
  return (
    <div tw="flex flex-col items-center justify-center flex-wrap gap-10">
      <h1 tw="text-xl font-medium text-gray-900 text-center">
        {t("error.noData")}
      </h1>
      {subtitle && <p>{subtitle}</p>}
      <Button
        red
        onClick={() =>
          logout({ logoutParams: { returnTo: window.location.origin } })
        }
        tw="w-fit"
      >
        {t("action.logOut")}
      </Button>
    </div>
  );
};

export default ErrorPage;
